import { render, staticRenderFns } from "./IncomeServiceDetailsPopup.vue?vue&type=template&id=048cf57e"
import script from "./IncomeServiceDetailsPopup.vue?vue&type=script&lang=js"
export * from "./IncomeServiceDetailsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports